import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'auto-table',
  templateUrl: './auto-table.component.html',
})
export class AutoTableComponent implements OnInit {
  @Input() emptyMessage: string = 'No data found';
  @Input() rows: any[];
  @Input() cols: any[];
  @Input() enableRowClick = false;
  @Input() loading = false;
  @Input() loadingRows = 5;
  @Output() onLinkClicked = new EventEmitter<any>();
  @Output() onRowClicked = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  public get displayedRows(): any[] {
    if (this.loading) {
      return Array.from({ length: this.loadingRows }, (_, index) => index);
    }

    return this.rows || [];
  }
}
